import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { radioUIComponent } from 'ctm-css-themes';
import { interpolateString } from 'ctm-util-functions';

import classNames from 'classnames';
import { getCheckboxDisabledProp, getRadioComponentStateSuffix } from '../utils';
import * as actions from '../actions';
import styles from './radio.css';

class Radio extends Component {

    /**
     * Call the setValue function when the value of the input has been changed
     * by the user.
     * @param {Object} event - event object
     */
    onChange = (event) => {
        event.persist();

        const { schema, dispatch, onClickFunction, optionProps = [] } = this.props;
        // Let's the parent perform any actions when clicked.
        if (onClickFunction) {
            onClickFunction(event);
        }

        // if checked, set the value, else, clear the value
        let value = '';
        if (event.target.checked) {
            value = event.target.value;
        }
        // todo: this needs to be investigated to trigger setFormValue, so that car colour page can auto progress.
        dispatch(
            actions.setValue(
                schema.backendIdentifier || schema.identifier,
                value,
                schema.stateKey
            )
        );

        let onClickActions = [];
        if (optionProps.onClickActions) {
            onClickActions = onClickActions.concat(optionProps.onClickActions);
        }
        if (schema.onClickActions) {
            onClickActions = onClickActions.concat(schema.onClickActions);
        }
        if (onClickActions.length) {
            onClickActions.forEach((action) => {
                // eslint-disable-next-line no-param-reassign
                action.stateKey = schema.stateKey;
                dispatch(action);
            });
        }
    };

    render = () => {
        const { controlPositionClassName, labelClassName, schema, value, optionProps, selectedValues } = this.props;
        const elementProps = optionProps || schema.field;
        const elementValue = interpolateString(elementProps.value)(selectedValues);
        const elementId = `${schema.identifier}.${elementValue}`;

        const isChecked = value === elementValue;

        // UI Component
        const UIComponentPrefix = radioUIComponent[elementProps.UIComponent] ? elementProps.UIComponent : 'radio_secondary_medium_rounded';
        const stateSuffix = getRadioComponentStateSuffix(this.props);
        const UIComponent = `${UIComponentPrefix}${stateSuffix}`;
        const componentClass = radioUIComponent[UIComponent];
        const labelStyle = classNames(
            styles[`label${stateSuffix}`],
            labelClassName ? styles[labelClassName] : ''
        );

        return (
            <label htmlFor={elementId} className={labelStyle}>
                <div className={controlPositionClassName}>
                    <span className={componentClass}>
                        <input
                            type="radio"
                            checked={isChecked}
                            onChange={this.onChange}
                            {...getCheckboxDisabledProp(this.props)}
                            name={schema.identifier}
                            value={elementValue}
                            id={elementId}
                            data-id={elementId}
                        />
                    </span>
                </div>
                {interpolateString(elementProps.label)(selectedValues)}
            </label>
        );
    };

}
Radio.propTypes = {
    onClickFunction: PropTypes.func,
    schema: PropTypes.shape({
        field: PropTypes.object.isRequired,
        identifier: PropTypes.string.isRequired,
        onClickActions: PropTypes.arrayOf(PropTypes.object),
        stateKey: PropTypes.string,
        backendIdentifier: PropTypes.string
    }).isRequired, // The schema for this form element
    optionProps: PropTypes.shape({
        value: PropTypes.string.isRequired,
        label: PropTypes.string
    }),
    value: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    selectedValues: PropTypes.object,
    controlPositionClassName: PropTypes.string,
    labelClassName: PropTypes.string
};
export { Radio };
